import React from "react";
import { useTranslation } from "react-i18next";
import AppFormTooltipWrap from "@ipru-common/components/CommonComponents/AppFormTooltipWrap";
import { DATALAYER_EVENTS } from "@ipru-common/constants/dataLayer";
import { PAGE_SECTIONS } from "@ipru-common/constants/products";
import { useDataLayer } from "@ipru-common/context/DataLayerContext";

const base = "savingsAppForm.tooltip";

export const AppFormTooltipCom = ({ info }) => {
  const { t } = useTranslation();

  return info?.content ? (
    <AppFormTooltipWrap content={info?.content}>
      <span className="text-[12px] ml-1.5 text-bright-red-100 underline cursor-pointer max-h-fit">
        {info?.title || t("appForm.personal_details.what_is_this")}
      </span>
    </AppFormTooltipWrap>
  ) : null;
};

export const AppFormToolTipWrapper = ({ children }) => {
  return <div className="pl-2 bg-sky-blue-300 text-navy-blue p-1.5 text-xs !font-normal rounded-md ">{children}</div>;
};

export const ProposerDetailsTooltip = () => {
  const { t } = useTranslation();
  return <AppFormToolTipWrapper>{t("savingsAppForm.tooltip.proposer_details")}</AppFormToolTipWrapper>;
};

export const LaDetailsTooltip = () => {
  const { t } = useTranslation();
  return <AppFormToolTipWrapper>{t("savingsAppForm.tooltip.life_assured_details")}</AppFormToolTipWrapper>;
};

export const ProposerBankTooltip = () => {
  const { t } = useTranslation();

  return (
    <AppFormToolTipWrapper>
      <ul className="list-disc pl-4">
        <li>
          <b>{t(`${base}.fatca_bank_type.1`)}</b>
          {t(`${base}.fatca_bank_type.2`)}
          <br></br>
        </li>
        <li>
          <b>{t(`${base}.fatca_bank_type.4`)}</b> {t(`${base}.fatca_bank_type.5`)}
        </li>
      </ul>
    </AppFormToolTipWrapper>
  );
};

export const PioOicTooltip = () => {
  const { t } = useTranslation();

  return (
    <AppFormToolTipWrapper>
      <ul className="list-disc pl-4">
        <li>
          <b>{t(`${base}.pio_oic.1`)}</b>
          {t(`${base}.pio_oic.2`)}
        </li>
        <li>
          <b>{t(`${base}.pio_oic.3`)}</b>
          {t(`${base}.pio_oic.4`)}
        </li>
        <li>
          <b>{t(`${base}.pio_oic.5`)}</b>
          {t(`${base}.pio_oic.6`)}
        </li>
      </ul>
    </AppFormToolTipWrapper>
  );
};

export const NomineeOtherReasonTooltip = () => {
  const { t } = useTranslation();

  return <span className="flex p-4">{t("savingsAppForm.tooltip.nominee_other_reason")}</span>;
};

export const NriAnnualIncomeTooltip = () => {
  const { t } = useTranslation();
  return (
    <AppFormToolTipWrapper>
      <span>{t(`${base}.nri_annual_income`)}</span>
    </AppFormToolTipWrapper>
  );
};

export const NriAnnualIncomeTooltipGiftCity = () => {
  const { t } = useTranslation();
  return (
    <AppFormToolTipWrapper>
      <span>{t(`${base}.nri_annual_income_gift_city`)}</span>
    </AppFormToolTipWrapper>
  );
};

export const CommunicationAddressTooltip = () => {
  const { t } = useTranslation();
  return (
    <AppFormToolTipWrapper>
      <span>{t(`${base}.proposer_communication`)}</span>
    </AppFormToolTipWrapper>
  );
};

export const IsLaRelationNriTooltip = () => {
  const { t } = useTranslation();

  return <AppFormToolTipWrapper>{t(`${base}.la_relation_nri`)}</AppFormToolTipWrapper>;
};

export const AccountInfo = ({ name, passbookRef }) => {
  const { t } = useTranslation();
  const pushDataLayerEvent = useDataLayer();
  const handleClick = () => {
    pushDataLayerEvent({
      event: DATALAYER_EVENTS.AppForm_PayoutDetails_ClickHere,
      currentSection: PAGE_SECTIONS.appFormPayoutAccDetail,
    });
    passbookRef?.current?.openModal(true);
    pushDataLayerEvent({
      event: DATALAYER_EVENTS.AppForm_AccDetails_PopUpOpen,
      currentSection: PAGE_SECTIONS.appFormPayoutAccDetail,
    });
  };
  return (
    <div>
      <p className="max-w-[100%] text-[10px] pb-[25px]">
        {t("appForm.payout_details.title_subtitle", { name: name || "" })} <br />
        {t("appForm.payout_details.title_subtitle2")}!!{" "}
        <span className="text-bright-red-100 underline cursor-pointer" onClick={handleClick}>
          {t("common.click_here")}
        </span>{" "}
        {t("appForm.payout_details.title_subtitle3")}
      </p>
      <span></span>
    </div>
  );
};

export const CancelledCheck = ({ cancelledCheckRef }) => {
  const { t } = useTranslation();
  const pushDataLayerEvent = useDataLayer();
  const handleClick = () => {
    pushDataLayerEvent({
      event: DATALAYER_EVENTS.AppForm_PayoutDetails_CancelCheque,
      currentSection: PAGE_SECTIONS.appFormPayoutDetails,
    });
    cancelledCheckRef?.current?.openModal(true);
    pushDataLayerEvent({
      event: DATALAYER_EVENTS.AppForm_PayoutDetails_CancelCheque_Open,
      currentSection: PAGE_SECTIONS.appFormPayoutDetails,
    });
  };
  return (
    <div className="flex md:mt-[25px] mt-[40px] items-start justify-center">
      <img src="/content/dam/aem-sites-react-spa-ssr/app-form/savingappform/hint-icon.svg" />
      <div className="md:text-[14px] text-[13px] md:text-center ml-[13px] text-start">
        {t("appForm.payout_details.cancelled_cheque_1st")}{" "}
        <span className="text-bright-red-100 underline cursor-pointer" onClick={handleClick}>
          {t("appForm.payout_details.cancelled_cheque_2nd")}
        </span>{" "}
        {t("appForm.payout_details.cancelled_cheque_3rd")}
      </div>
    </div>
  );
};

export const AddressTooltip = ({ suffix }) => {
  const { t } = useTranslation();
  return (
    <div className="pl-2 p-1.5 text-xs !font-normal rounded-md">
      <span>{t(`${base}.${suffix}`)}</span>
    </div>
  );
};
